import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
    selector: 'app-users-list-dialog',
    templateUrl: './users-list-dialog.component.html',
    styleUrls: ['./users-list-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersListDialogComponent implements OnInit {

  userData : any;
  sharedDataContent: any;
  constructor(public dialogRef: MatDialogRef<UsersListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User[],
    private readonly authService: AuthService) { 
      this.authService.sharedData$.subscribe((res:any)=> {
        if (res) {
          this.sharedDataContent = res;
        }
      })
    }

  ngOnInit() {
    this.userData = this.data;
  }

}

export interface User {
  userName: string;
  userEmail: string;
  status: string;
}
